// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__tmm76","right":"Footer_right__Eeb2v","buttons":"Footer_buttons__1PziN"};